import { axiosAuthClient, axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const USER_BASE_URL = "/user";

class AuthService {
  // Register new user
  register = async ({ email, password, confirmPassword }) => {
    try {
      const response = await axiosAuthClient.post(
        `/register`,
        { email, password, confirmPassword },
        { withCredentials: true }
      );
      if (response.status !== 201) {
        throw new Error();
      }
      const { user } = response.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Greška prilikom registracije");
    }
  };

  // Login user
  login = async ({ email, password }) => {
    try {
      const response = await axiosAuthClient.post(
        `/login`,
        { email, password },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Greška prilikom prijave");
    }
  };

  // Logout user
  logout = async () => {
    try {
      const response = await axiosAuthClient.post(
        `/logout`,
        {},
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom odjave");
    }
  };

  // Verify email
  verifyEmail = async ({ token }) => {
    try {
      const response = await axiosAuthClient.post(
        `/verify-email`,
        { token },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom verifikacije email-a");
    }
  };

  // Resend verification email
  resendVerification = async ({ email }) => {
    try {
      const response = await axiosAuthClient.post(
        `/resend-verification`,
        { email },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom slanja verifikacionog email-a");
    }
  };

  // Forgot password
  forgotPassword = async ({ email }) => {
    try {
      const response = await axiosAuthClient.post(
        `/forgot-password`,
        { email },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom zahteva za resetovanje šifre");
    }
  };

  // Reset password
  resetPassword = async ({ token, password }) => {
    try {
      const response = await axiosAuthClient.post(
        `/reset-password`,
        { token, password },
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom resetovanja šifre");
    }
  };

  // Refresh token
  refresh = async () => {
    try {
      const response = await axiosApiClient.post(
        `${USER_BASE_URL}/refresh`,
        {},
        { withCredentials: true }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Greška prilikom obnove sesije");
    }
  };

  // Get current user info
  getUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${USER_BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja podataka korisnika");
    }
  };

  // Update user profile
  updateProfile = async (profileData) => {
    try {
      const response = await axiosApiClient.put(
        `${USER_BASE_URL}/profile`,
        profileData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Greška prilikom ažuriranja profila");
    }
  };

  // Change password
  changePassword = async (passwordData) => {
    try {
      const response = await axiosApiClient.put(
        `${USER_BASE_URL}/change-password`,
        passwordData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom promene šifre");
    }
  };

  // Get user statistics
  getUserStatistics = async () => {
    try {
      const response = await axiosApiClient.get(`${USER_BASE_URL}/statistics`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { statistics } = response.data;
      return { statistics };
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja statistike");
    }
  };

  // Get user achievements
  getUserAchievements = async () => {
    try {
      const response = await axiosApiClient.get(
        `${USER_BASE_URL}/achievements`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { achievements } = response.data;
      return { achievements };
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja dostignuća");
    }
  };

  // Get user dashboard data
  getUserDashboard = async () => {
    try {
      const response = await axiosApiClient.get(`${USER_BASE_URL}/dashboard`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { dashboard } = response.data;
      return { dashboard };
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja panela");
    }
  };
}

const authService = new AuthService();

export default authService;
